import React from "react";
import { Link } from "react-router-dom";
import { openConsentSettings } from "@/lib/consent";
import { useI18n } from "@/context/I18nContext";

export default function SiteFooter() {
  const { lang } = useI18n();
  const en = lang === "en";
  const cls = "hover:text-foreground hover:underline transition-colors";
  return (
    <footer className="mt-8 border-t border-border py-6 label-caps" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 sm:flex-row sm:justify-between sm:px-6">
        <span>© {new Date().getFullYear()} Waterplanner</span>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link to="/impressum" className={cls} data-testid="footer-impressum-link">{en ? "Legal notice" : "Impressum"}</Link>
          <Link to="/datenschutz" className={cls} data-testid="footer-privacy-link">{en ? "Privacy policy" : "Datenschutz"}</Link>
          <button type="button" onClick={openConsentSettings} className={`${cls} uppercase`} data-testid="footer-cookie-settings-btn">
            {en ? "Cookie settings" : "Cookie-Einstellungen"}
          </button>
        </nav>
      </div>
    </footer>
  );
}
